import { CatModel } from "../models/cat";
import { createDataStore } from "../utils/data_score";

const CAT_KEY = "marjo90rie-cat";

const catStore = createDataStore<CatModel[]>(getCatsFromLocalStorage());

export const useCats = catStore.useData;

export function addCatToGlobalStore(cat: CatModel) {
  const previous = catStore.getData();
  const allCats = [cat, ...previous];
  catStore.setData(allCats);
  localStorage.setItem(CAT_KEY, JSON.stringify(allCats));
}

function getCatsFromLocalStorage(): CatModel[] {
  try {
    return JSON.parse(localStorage.getItem(CAT_KEY) ?? "[]");
  } catch {
    return [];
  }
}
